import { path } from 'ramda'

export default {
  corePageLoadComplete: path(['corePageLoadComplete']),
}
